import { render, staticRenderFns } from "./PromotionsPage.vue?vue&type=template&id=12b58de0&scoped=true&"
import script from "./PromotionsPage.vue?vue&type=script&lang=js&"
export * from "./PromotionsPage.vue?vue&type=script&lang=js&"
import style0 from "./PromotionsPage.vue?vue&type=style&index=0&id=12b58de0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b58de0",
  null
  
)

export default component.exports